import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinnerThird } from '@fortawesome/sharp-solid-svg-icons';
import { useEffect } from 'react';
import './index.css';

interface SCLoadingOverlayProps {
  Visible: boolean;
  Label?: string;
}

function SCLoadingOverlay(props: SCLoadingOverlayProps) {
  useEffect(() => {
    if (props.Visible == false) return;
    // Dropdown panels portal to body above the modal layer, so they'd paint over
    // (and stay clickable through) this overlay; the overlay itself must stay BELOW
    // modals (SC-1119), so close the panels instead of out-z-indexing them (SC-1067).
    // The string literal (not eone-ui's CLOSE_DROPDOWN_PANELS_EVENT) keeps this a
    // no-op with eone-ui builds that don't have the listener yet.
    window.dispatchEvent(new Event('eone-ui:close-dropdown-panels'));
  }, [props.Visible]);

  const getLabel = () => {
    if (props.Label == undefined || props.Label == null) {
      return 'Loading...';
    } else {
      return props.Label;
    }
  };

  if (props.Visible == false) return null;
  return (
    <div className="sc-loading-container">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 20 }}>
        <FontAwesomeIcon className="sc-loading-icon" icon={faSpinnerThird} spin />
        <p className="sc-loading-label">{getLabel()}</p>
      </div>
    </div>
  );
}

export { SCLoadingOverlay };
